export default "__VITE_ASSET__9HTcgBIz__"